module.exports = __webpack_public_path__ + "static/media/Construction.f9233b41.svg";